import { AppContext } from "../core/context";
import { adjustCameraView } from "../scene/camera";
import { AppSettings } from "../settings";
import { Entity, Module, Product } from "../types/type_def";
import { removeEntityConnections } from "./connectors";
import { constructModule } from "./construction";
import { deleteEntity } from "./entities";

export function createActionButton(ctx: AppContext, module: Module, entity: Entity, name: string, textureUrl: string, onPointerDown: any, onPointerUp: any) {

    var actionButton = new BABYLON.GUI.Image(module.id + "_" + entity.id + "_" + name, textureUrl);
    actionButton.paddingBottom = "2px";
    actionButton.paddingLeft = "2px";
    actionButton.paddingTop = "2px";
    actionButton.paddingRight = "2px";
    actionButton.width = "48px";
    actionButton.height = "48px";
    actionButton.metadata = {};
    actionButton.metadata.entityId = entity.id;
    actionButton.isEnabled = true;
    actionButton.isPointerBlocker = true;
    actionButton.alpha = 0.6;
    actionButton.onPointerEnterObservable.add(function (e, ec) {
        actionButton.alpha = 1;
    });
    actionButton.onPointerOutObservable.add(function (e, ec) {
        actionButton.alpha = 0.6;
    });
    actionButton.onPointerUpObservable.add(function (e, ec) {
        actionButton.alpha = 0.6;

        if (typeof (onPointerUp) === "function") {
            onPointerUp(e, ec);
        }
    });
    actionButton.onPointerDownObservable.add(function (e, ec) {
        actionButton.alpha = 1;
        if (typeof (onPointerDown) === "function") {
            onPointerDown(e, ec);
        }
    });
    return actionButton;

}

export function createCenter(ctx: AppContext, module: Module, entity: Entity, scene: BABYLON.Scene) {

    var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
    if (entityNode) {
        var entityBounds = entityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
        var entityExtendSize = entityBounds.getBoundingInfo().boundingBox.extendSize;

        var centerNode = new BABYLON.TransformNode("center", scene);
        centerNode.parent = entityNode;
        centerNode.position.addInPlace(new BABYLON.Vector3(0, 0, entityExtendSize.z));
        centerNode.setEnabled(true);
        centerNode.computeWorldMatrix(true);
    }
}

export function createEntityActions(ctx: AppContext, module: Module, entity: Entity, scene: BABYLON.Scene, product: Product) {

    var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
    if (entityNode) {

        var actionContainer = new BABYLON.GUI.StackPanel(module.id + "_" + entity.id + "_actionContainer");
        actionContainer.isVertical = false;

        //Rotate action
        let actionRotateButton = createActionButton(ctx, module, entity, "action_rotate", AppSettings.Paths.RotateIcon, function (e, ec) {

            var entityId = ec.target.metadata.entityId;
            var entity = ctx.moduleHelper.getEntityByID(module, entityId);// currentModule.entities.find(function (e) { return e.id === entityId });

            removeEntityConnections(ctx, entity);               

            entity.rotation.y += Math.PI / 2;
            ctx.currentConnector = null;
            ctx.currentEntityNode = null;
            
            constructModule(ctx, ctx.currentModule).then(() => {   

                //validateConstruction(currentModule); 
                //zoomToMeshHierarchy(mainCamera, currentModuleNode, scene, mainCamera.alpha, mainCamera.beta, 2); 
              //  fitView(currentModuleNode, mainCamera);
               // handleModuleUpdating();
            });             


        }, null);
        actionContainer.addControl(actionRotateButton);

        //Delete action
        let actionDeleteButton = createActionButton(ctx, module, entity, "action_delete", AppSettings.Paths.DeleteIcon, function (e, ec) {

            var entityId = ec.target.metadata.entityId;
            var entity = ctx.moduleHelper.getEntityByID(module, entityId);

            if (entity) {
                hideEntityActions(ctx);
                deleteEntity(ctx, entity);
            }
            
            constructModule(ctx, ctx.currentModule).then(() => {
                adjustCameraView(ctx, ctx.mainCamera, ctx.currentModuleNode, scene, ctx.mainCamera.alpha, ctx.mainCamera.beta, ctx.mainCamera.radius, ctx.defaultMinCameraRadius);
               // handleModuleUpdating();
            });

        }, null);
        actionContainer.addControl(actionDeleteButton);

        ctx.GUI.addControl(actionContainer);

        var centerNode = entityNode.getChildTransformNodes(true, function (t) { return t.id === "center" })[0];
        actionContainer.linkWithMesh(centerNode);

       /* var labelContainer = new BABYLON.GUI.Rectangle(module.id + "_" + entity.id + "_label");
        labelContainer.width = "220px";
        labelContainer.height = "52px";
        labelContainer.cornerRadius = 4;
        labelContainer.color = "black";
        labelContainer.thickness = 1;
        labelContainer.background = "white";
        GUI.addControl(labelContainer);
        labelContainer.linkWithMesh(centerNode);
        labelContainer.linkOffsetY = -16;

        labelContainer.isVisible = false;

        var productVariant = productLibrary.getProductVariantByConnectionType(product, moduleHelper.getEntityConnectionType(module, entity));

        var text1 = new BABYLON.GUI.TextBlock(module.id + "_" + entity.id + "_productNo");
        text1.text = product.productNo.replace("/", "/\r\n") + "\r\n" + productVariant.axProductNo;
        text1.color = "black";
        text1.fontSize = 14;
        labelContainer.addControl(text1);*/
    }
}

export function showEntityActions(ctx: AppContext) {

    ctx.GUI.rootContainer.children.forEach(function (c) {

        if (ctx.currentEntityNode) {
            if (c.name.indexOf(ctx.currentModuleNode.id + "_" + ctx.currentEntityNode.id + "_actionContainer") >= 0) {
                c.isVisible = true;
            }
        }
    });
}

export function hideEntityActions(ctx: AppContext) {

    ctx.GUI.rootContainer.children.forEach(function (c) {
        if (c.name.indexOf("_actionContainer") >= 0) {
            c.isVisible = false;
        }
    });
}
